import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import Hero from '../components/RealEstateAgentsLanding/Hero'
import SocialProof from '../components/RealEstateAgentsLanding/SocialProof'
import CampaignStrategy from '../components/RealEstateAgentsLanding/CampaignStrategy'
import WhyOLM from '../components/RealEstateAgentsLanding/WhyOLM'
import HowItWorks from '../components/RealEstateAgentsLanding/HowItWorks'
import FAQ from '../components/RealEstateAgentsLanding/FAQ'
import BookingSection from '../components/RealEstateAgentsLanding/BookingSection'
import Footer from '../components/Footer'

export default function RealEstateAgents({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <Hero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .agents-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .agents-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .agents-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/real-estate-agents')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
